<template>
  <DynamicTableWithTabs />
</template>

<script>
import DynamicTableWithTabs from "./components/sortTable.vue";

export default {
  name: "App",
  components: {
    DynamicTableWithTabs,
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
